import BaseModelAPI from '../BaseModelAPI';

export default class DeliveryQualityInspectionCard extends BaseModelAPI {
	static entity = 'deliveryqualityinspectioncard';
	static entityName = 'deliveryqualityinspectioncard';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.deliveryQualityInspectionId = '';
			this.deliveryQualityInspection = {};
			this.deliveryQualityInspectionDetailId = '';
			this.deliveryQualityInspectionDetail = {};
			this.deliveryCardId = '';
			this.deliveryCard = {};
			this.qcStatusId = '';
			this.qcStatus = {};
			this.remarks = '';
			this.qcDate = '';
			this.qcById = '';
			this.qcBy = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}